/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const PlayIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' {...props}>
			<g data-name='Group 96'>
				<path data-name='Path 156' d='M0 18.991V0l17.164 9.493Z' fill={color} />
			</g>
		</svg>
	)
}

export default PlayIcon
